@if (!!value || showFieldAsEdit) {
  <div
    class="field"
    >
    <label class="upper">{{ displayName }}</label>
    @if (showFieldAsEdit) {
      <div>
        <ng-select
          [items]="users"
          [(ngModel)]="selectedUser"
          (ngModelChange)="(onValueChanged)"
          bindLabel="displayName"
          [multiple]="false"
          [minTermLength]="2"
          [loading]="usersLoading"
          (search)="usersInput$.next($event.term)"
          typeToSearchText="Please enter 2 or more characters"
          [clearable]="true">
          <ng-template
            ng-label-tmp
            ng-option-tmp
            let-item="item">
            <div
              class="px-2 py-2"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="12px">
              <topo-avatar
                [name]="item?.displayName || item?.emailAddress"
              [imageUrl]="item?.profilePhotoUrl"></topo-avatar>
              <div>
                <div fxLayout="row">
                  <div class="has-text-weight-semibold">{{ item?.displayName }}</div>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    } @else {
      @if (selectedUser) {
        <div
          class="px-2 py-2"
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="12px">
          <topo-avatar
            [name]="selectedUser?.displayName || selectedUser?.emailAddress"
          [imageUrl]="selectedUser?.profilePhotoUrl"></topo-avatar>
          <div>
            <div fxLayout="row">
              <div class="has-text-weight-semibold">{{ selectedUser?.displayName }}</div>
            </div>
          </div>
        </div>
      } @else {
        <div>---</div>
      }
    }
  </div>
}
